import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { ProductOverviewModel } from '../../Models/Models/Account/ProductOverviewModel';
import { AccountStatus } from '../../Models/Domains/Account/SlAccounts/AccountStatus';

declare var IS_RUNNING_IN_APP_POOL;

export class ProductOverviewClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(subAccountHierarchyId: string): Promise<ProductOverviewModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/ProductOverview/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { subAccountHierarchyId: subAccountHierarchyId }

    return AjaxWrapper.get<ProductOverviewModel, any>(url, data);
  }
  public put(hierarchyId: string, name: string, accountStatus: AccountStatus): Promise<string, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Account/ProductOverview/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { hierarchyId: hierarchyId, name: name, accountStatus: accountStatus }

    return AjaxWrapper.post<string, any>(url, data);
  }
}

